import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 8px;

  .stat-value {
    font-size: 24px;
    line-height: 1.2;
    color: ${(props) => props.theme.$dark};
  }

  .stat-label {
    font-size: 14px;
  }
`;
